module.exports = __webpack_public_path__ + "img/dl3dvn-currency-guide-4.77366149.png";